import { jsx } from "react/jsx-runtime";
import { loginForm } from "../../loginFormSetup.js";
import { useTexts } from "./useTexts.js";
function RememberMe(props) {
  const { componentProps, fieldProps } = props;
  const texts = useTexts();
  const mergedUserSx = {
    ...componentProps?.formControlLabelProps?.sx,
    ...fieldProps?.formControlLabelProps?.sx
  };
  return /* @__PURE__ */ jsx(
    loginForm.Checkbox,
    {
      name: "rememberMe",
      label: texts,
      validateOn: "blur",
      checkboxProps: {
        ...componentProps?.checkboxProps,
        ...fieldProps?.checkboxProps
      },
      formControlLabelProps: {
        ...componentProps?.formControlLabelProps,
        ...fieldProps?.formControlLabelProps,
        sx: {
          maxWidth: "fit-content",
          ...mergedUserSx
        }
      }
    }
  );
}
export {
  RememberMe
};
//# sourceMappingURL=RememberMe.js.map
